import { useState } from "react";
import { useDbClient, useLiveQuery } from "@tanstack/react-db";
import {
  communityNavigation,
  communityAccess,
} from "@softmax/web-features/community";
import {
  collectionError,
  refreshCollections,
} from "@softmax/web-features/data";
import { ForumWikiRailView } from "@softmax/web-ux/forum";
import { wikiIndexCollection } from "../wiki/wiki.collections";
import { renderLink } from "./forum-links";

export function WikiRail({
  slug,
  basePath,
}: {
  slug: string;
  basePath: string;
}) {
  const navigation = communityNavigation({ basePath });
  const descriptor = wikiIndexCollection({
    wikiSlug: slug,
    elevatedPrivileges: false,
  });
  const db = useDbClient();
  const source = db.collection(descriptor);
  const query = useLiveQuery((q) => q.from({ page: descriptor }));
  const { accessLost } = communityAccess([query.health]);
  const [refreshing, setRefreshing] = useState(false);
  return (
    <ForumWikiRailView
      state={
        query.isReady && !accessLost
          ? {
              status: "ready",
              pages: query.data.slice(0, 6).map((page) => ({
                id: page.id,
                title: page.title,
                href: navigation.wikiPageHref({ pageSlug: page.slug }),
              })),
              refreshing,
              refreshError: query.isSyncError
                ? "Couldn't refresh the wiki."
                : undefined,
            }
          : collectionError(query.health) && !refreshing
            ? { status: "error", message: "Couldn't load the wiki." }
            : { status: "loading" }
      }
      wikiHref={navigation.wikiPageHref({ pageSlug: "main" })}
      onRefresh={() => {
        setRefreshing(true);
        const request = refreshCollections({
          signal: db.requireDependency<AbortController>("lifetime").signal,
          queries: [query.collection],
          refresh: () => source.utils.refetch({ throwOnError: true }),
        });
        void request.finally(() => setRefreshing(false));
      }}
      renderLink={renderLink}
    />
  );
}
